'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Scrollbar = require('./Scrollbar');

var _Scrollbar2 = _interopRequireDefault(_Scrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Scrollbar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Scrollbar/index.js
// module id = 641
// module chunks = 11